import type { PlayerSinglePayload } from '@/services/quizzes';
import styles from './QuizQuestion.module.scss';

interface MultipleQuestionProps {
  payload: PlayerSinglePayload;
  value: string[];
  onChange: (selectedIds: string[]) => void;
  disabled?: boolean;
  reveal?: { selectedIds: string[] };
}

export function MultipleQuestion({ payload, value, onChange, disabled, reveal }: MultipleQuestionProps) {
  function toggle(id: string) {
    if (disabled) return;
    if (value.includes(id)) onChange(value.filter((x) => x !== id));
    else onChange([...value, id]);
  }
  const submitted = new Set(reveal?.selectedIds ?? []);
  return (
    <ul className={styles.optionList}>
      {payload.options.map((opt) => {
        const selected = value.includes(opt.id);
        let extra = '';
        if (reveal) {
          // verde si correcta (sea seleccionada o no); rojo si el alumno la seleccionó y no es correcta.
          if (opt.is_correct) extra = styles.optionCorrect ?? '';
          else if (submitted.has(opt.id)) extra = styles.optionIncorrect ?? '';
        } else if (selected) {
          extra = styles.optionSelected ?? '';
        }
        return (
          <li key={opt.id}>
            <label className={`${styles.option} ${extra}`}>
              <input
                type="checkbox"
                checked={selected}
                onChange={() => toggle(opt.id)}
                disabled={disabled}
                style={{ display: 'none' }}
              />
              <span className={`${styles.checkbox} ${selected ? styles.checkboxChecked : ''}`} aria-hidden="true">
                {selected ? '✓' : ''}
              </span>
              <span className={styles.label}>{opt.text}</span>
            </label>
          </li>
        );
      })}
    </ul>
  );
}
